import { useEffect, useState } from 'react';
import { collection, doc, getDocs, query, where } from 'firebase/firestore';
import { db } from '@/firebase';
import { useAuth } from '@/contexts/AuthContext';

export const REQUIRED_EXAM_COURSE = '通信講座＋試験';

export default function useCourseAccess() {
  const { userId } = useAuth();
  const [loading, setLoading] = useState(true);
  const [hasEligibleCourse, setHasEligibleCourse] = useState(false);

  useEffect(() => {
    const checkEligibleCourse = async () => {
      if (!userId) {
        setHasEligibleCourse(false);
        setLoading(false);
        return;
      }

      try {
        const userRef = doc(db, 'User', userId);
        const ordersQuery = query(
          collection(db, 'Order'),
          where('UserRef', '==', userRef),
          where('status', '==', 'active')
        );

        const snapshot = await getDocs(ordersQuery);
        const eligible = snapshot.docs.some((orderDoc) => {
          const course = orderDoc.data().course;
          return typeof course === 'string' && course.trim() === REQUIRED_EXAM_COURSE;
        });

        setHasEligibleCourse(eligible);
      } catch (error) {
        console.error('Failed to check course access:', error);
        setHasEligibleCourse(false);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    checkEligibleCourse();
  }, [userId]);

  return { hasEligibleCourse, loading };
}
